import { render, staticRenderFns } from "./InterventionStatusNotificationsList.vue?vue&type=template&id=97345488"
import script from "./InterventionStatusNotificationsList.vue?vue&type=script&lang=ts"
export * from "./InterventionStatusNotificationsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports